module.exports = __webpack_public_path__ + "img/27.9.TU.43bf6017.png";